// extracted by mini-css-extract-plugin
export var phone = "_3i-0";